import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import { Icon } from "@iconify/react";
import moreVerticalFill from "@iconify/icons-eva/more-vertical-fill";
import editFill from "@iconify/icons-eva/edit-fill";
import trash2Outline from "@iconify/icons-eva/trash-2-outline";
import { useMutate } from "src/hooks/useFetch.hook";
import { paymentGatewayDetailByIdUrl } from "src/react-query/endPoints";
import { alertSlice } from "src/store/alert/alert.slice";
import { useDispatch } from "react-redux";
import { useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "src/react-query/queryKeys";

export const PaymentGatewayActionMenu = ({ id, row }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const { mutate, isLoading } = useMutate("paymentGatewayDetails");

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = () => {
    navigate(`/payment-gateways/${id}`);
    handleClose();
  };

  const handleDelete = () => {
    if (window.confirm("Are you sure you want to delete this payment gateway?")) {
      mutate(
        {
          url: paymentGatewayDetailByIdUrl(id),
          method: "DELETE",
        },
        {
          onSuccess: () => {
            dispatch(
              alertSlice.actions.setAlert({
                open: true,
                message: "Payment gateway deleted successfully",
                severity: "success",
              })
            );
            queryClient.invalidateQueries(queryKeys.paymentGatewayDetails());
            handleClose();
          },
          onError: (error) => {
            dispatch(
              alertSlice.actions.setAlert({
                open: true,
                message: error?.message || "Failed to delete payment gateway",
                severity: "error",
              })
            );
          },
        }
      );
    }
  };

  return (
    <>
      <IconButton onClick={handleClick}>
        <Icon icon={moreVerticalFill} width={20} height={20} />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuItem onClick={handleEdit}>
          <ListItemIcon>
            <Icon icon={editFill} width={20} height={20} />
          </ListItemIcon>
          <ListItemText>Edit</ListItemText>
        </MenuItem>
        <MenuItem onClick={handleDelete} disabled={isLoading}>
          <ListItemIcon>
            <Icon icon={trash2Outline} width={20} height={20} />
          </ListItemIcon>
          <ListItemText>Delete</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};

